/**
 * ============================================================================
 * ReferralForm / ReferralFormNew — Service (API calls)
 * ============================================================================
 * Pure fetch wrappers. checkstatus/otp + verify + referralform/submit.
 * Counsellor analytics via FAQ connectCounsellorApiCall.
 * ============================================================================
 */

import { connectCounsellorApiCall } from "@/components/organisms/faq-hub/HomeNewFaq/HomeConnectModalFormFAQ/utils";
import {
  getCheckStatusOtpHash,
  getStoredOtpData,
  isStoredOtpExpired,
  sendCheckStatusOtp,
  storeOtpData,
  verifyReferralOtp,
} from "../../../shared/referralOtp";

export async function sendReferralCheckStatusOtp(emailOrPhone: string) {
  const result = await sendCheckStatusOtp({
    emailOrPhone,
    otpFor: "Referral",
  });
  if (result.ok && result.response?.Status === "Sent" && result.data) {
    storeOtpData(result.data);
  }
  return result;
}

export async function verifyReferralFormOtp(params: {
  mobile: string;
  otp: string;
}): Promise<{ success: boolean; expired?: boolean; missingOtp?: boolean; response?: any }> {
  let { mobile, otp } = params;
  try{
    const nextUrl = "/api/referral/checkstatus/verify";
    const response = await fetch(nextUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: mobile,
        otp: otp,
      }),
    });

    const data = await response.json();
    const res = data?.response?.response || {};
    if (data.isExpired) {
      return { success: false, expired: true, missingOtp: false };
    }
    if (!data.success) {
      return { success: false, expired: false, missingOtp: true };
    }

    let resObj = {email:res?.AmityEmail,name:res?.Name,phone:res?.Phone, ...res};
    return { success: true, response: resObj };
  }catch(err){
    return { success: false, expired: false, missingOtp: true };
  }
}

export async function submitReferralLead(body: Record<string, unknown>) {
  const response = await fetch("/api/referral/referralform/submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  return response.json();
}

export function trackReferralCounsellor(
  status: boolean,
  form: Record<string, unknown>,
  ipStackDetails: unknown,
  tracking: Record<string, unknown>,
) {
  return connectCounsellorApiCall(status, form, ipStackDetails, tracking);
}
